import React from "react";

import { BrowserRouter as Router, Route } from "react-router-dom";
import { Link } from "react-router-dom";

import "./MainComponent.css";

import GitHubProject from "../GithubProject/GitHubProject.component";
import HomePage from "../HomePage/HomePage.component";
import Cv from "../cv/cv.component";
import Blog from "../BlogComponent/bloglist.component";

import AdminComponent from "../AdminComponent/admin.component";
import Adminproject from "../AdminComponent/AdminProjectComponent/adminproject.component";
import AdminExperience from "../AdminComponent/AdminExperience/adminexperience.component";
import AdminEducation from "../AdminComponent/AdminEducationComponent/admineducation.component";
import AdminBlog from "../AdminComponent/AdminBlogComponent/adminblog.component";
import AdminCertifications from "../AdminComponent/AdminCertificationsComponent/admincertifications.component";
import AdminAchievement from "../AdminComponent/AdminAchievement/adminachievement.component";
import YoutubeComponent from "../YoutubeComponent/youtube.component";

import LOGO from "./img/senura3.jpg";

export default function MainComponent() {
  return (
    <div>
      {/* Start Navbar */}
      <nav
        class="navbar navbar-dark navbar-expand-lg fixed-top  bg-white portfolio-navbar gradient"
        style={{
          background: "rgb(2,0,36)",
          background:
            "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(3,7,44,1) 0%, rgba(13,105,157,1) 45%, rgba(28,126,163,1) 100%, rgba(0,212,255,1) 100%)",
          background: "white",
        }}
      >
        <div class="container">
          <a
            class="navbar-brand logo"
            href="/"
            style={{ color: "rgba(13,105,157,1)", fontWeight: "bolder" }}
          >
            <span className="DesktopNav">
              <img
                src={LOGO}
                style={{ width: "70px", height: "70px", borderRadius: "50%" }}
              />
              &nbsp;&nbsp; SENURA JAYADEVA
            </span>
            <span className="MobileNav">SENURA JAYADEVA</span>
          </a>
          <button
            data-toggle="collapse"
            class="navbar-toggler"
            data-target="#navbarNav"
          >
            <span class="sr-only">Toggle navigation</span>
            <span
              class="navbar-toggler-icon"
              style={{ backgroundColor: "rgba(13,105,157,1)" }}
            ></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="nav navbar-nav ml-auto">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  href="/"
                  style={{ color: "rgba(13,105,157,1)", fontWeight: "bolder" }}
                >
                  HOME
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link active"
                  href="/gitrepos"
                  style={{ color: "rgba(13,105,157,1)", fontWeight: "bolder" }}
                >
                  GIT PROJECTS
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link active"
                  href="/blog"
                  style={{ color: "rgba(13,105,157,1)", fontWeight: "bolder" }}
                >
                  BLOGS
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link active"
                  href="/youtube"
                  style={{ color: "rgba(13,105,157,1)", fontWeight: "bolder" }}
                >
                  YOUTUBE
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <br />

      {/* End Navbar */}

      <Router>
        <Route path="/" exact component={HomePage} />
        <Route path="/gitrepos" exact component={GitHubProject} />
        <Route path="/cv" exact component={Cv} />
        <Route path="/admin" exact component={AdminComponent} />
        <Route path="/adminproject" exact component={Adminproject} />
        <Route path="/adminexperience" exact component={AdminExperience} />
        <Route
          path="/admincertifications"
          exact
          component={AdminCertifications}
        />
        <Route path="/adminachievements" exact component={AdminAchievement} />
        <Route path="/admineducation" exact component={AdminEducation} />
        <Route path="/adminblog" exact component={AdminBlog} />
        <Route path="/blog" exact component={Blog} />
        <Route path="/youtube" exact component={YoutubeComponent} />
      </Router>
    </div>
  );
}
